<template>
  <!-- Sticky card -->
  <div class="container d-lg-block d-none">
    <div class="bg-primary sticky-card pt-1 shadow" :class="showSticky == true ? 'w-262px overflow-hidden' : 'px-2'">
      <button v-if="showSticky" @click="showSticky = !showSticky" class="btn mt-0 mx-2 opacity-50">
        <img src="@/assets/images/exit.svg" alt="" />
      </button>
      <div class="d-flex align-items-center gap-2 justify-content-center">
        <div @click="showSticky = !showSticky" role="button" class="text-white fs-6 fw-bold">
          <img src="@/assets/images/jadsticky.svg" class="jadewllha-icon" :class="showSticky == true ? 'removeTranslate' : ''" alt="" />
          <span class="pe-3" v-if="!showSticky">لنبدأ معا الآن</span>
        </div>
      </div>
      <div class="" v-if="showSticky">
        <div class="fs-14px text-white text-center fw-bold pb-3 mx-3">اهلا بك سأكون مرشدك لتكون جاهزا لاستقبال اول حجز لك على منصة جدولها</div>
        <div class="bg-light">
          <div class="mx-3">
            <div class="custom-progress d-flex gap-1 py-2">
              <div class="step done"></div>
              <div class="step"></div>
              <div class="step"></div>
            </div>
            <h5 class="fs-14px fw-bold mb-0">ثلاث مراحلة سهلة وبسيطة!</h5>

            <div>
              <a class="text-decoration-none w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                <div class="d-flex align-items-center border-bottom py-2 gap-3">
                  <div class="mb-auto">
                    <img src="@/assets/images/Check.svg" alt="" />
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fs-14px fw-bold">انشاء اول حدث</div>
                    <span class="fs-10px text-secondary">لعرض والتعديل على البيانات</span>
                  </div>
                  <div class="ms-auto">
                    <img src="@/assets/images/chevron-backward.svg" alt="" />
                  </div>
                </div>
              </a>
              <div class="collapse" id="collapseExample">
                <div class="card card-body border-0">نص يمكن استبداله</div>
              </div>
            </div>

            <div>
              <a class="text-decoration-none w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample1">
                <div class="d-flex align-items-center border-bottom py-2 gap-3">
                  <div class="mb-auto">
                    <img src="@/assets/images/Check.svg" alt="" />
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fs-14px fw-bold">ربط الكلاندر مع جوجل</div>
                    <span class="fs-10px text-secondary">كل ماعليك تسجيل الدخول فقط</span>
                  </div>
                  <div class="ms-auto">
                    <img src="@/assets/images/chevron-backward.svg" alt="" />
                  </div>
                </div>
              </a>
              <div class="collapse" id="collapseExample1">
                <div class="card card-body border-0">نص يمكن استبداله</div>
              </div>
            </div>
            <div>
              <a class="text-decoration-none w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample2">
                <div class="d-flex align-items-center border-bottom py-2 gap-3">
                  <div class="mb-auto">
                    <img src="@/assets/images/Check.svg" alt="" />
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fs-14px fw-bold">عرض صفحة الحجز</div>
                    <span class="fs-10px text-secondary">استعرض اللينك وارسله لعميلك</span>
                  </div>
                  <div class="ms-auto">
                    <img src="@/assets/images/chevron-backward.svg" alt="" />
                  </div>
                </div>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body border-0">نص يمكن استبداله</div>
              </div>
            </div>

            <div class="fs-12px text-center py-3">
              إذا واجهتك مشاكل
              <a href="#" class="text-primary fw-bold">تواصل معنا</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {ref} from '@vue/reactivity'
export default {
  setup() {
    const showSticky = ref(false)

    return {showSticky}
  },
}
</script>

<style>
.w-fitcontent {
  width: fit-content !important;
}
.w-262px {
  width: 262px !important;
}
</style>